module.exports = __webpack_public_path__ + "img/envelope3.f5707e0c.png";